/**
 * PLP size-line chips on .product-card[data-product-line].
 * Swaps title/price/image/links without page reload.
 *
 * @param {ParentNode} [root=document]
 */
export function initProductCardLine(root = document) {
  const cards = root.querySelectorAll('.product-card[data-product-line]');

  cards.forEach((card) => {
    if (!(card instanceof HTMLElement) || card.dataset.productLineInited === '1') {
      return;
    }
    card.dataset.productLineInited = '1';

    card.addEventListener('click', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) {
        return;
      }

      const option = target.closest('[data-product-line-option]');
      if (!(option instanceof HTMLElement) || !card.contains(option)) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      if (option.disabled || option.getAttribute('data-available') === '0') {
        return;
      }

      const id = option.getAttribute('data-id') || '';
      if (!id || id === card.dataset.activeId) {
        return;
      }

      applyVariant(card, option);
    });
  });
}

/**
 * @param {HTMLElement} card
 * @param {HTMLElement} option
 */
function applyVariant(card, option) {
  const id = option.getAttribute('data-id') || '';
  const url = option.getAttribute('data-url') || '';
  const title = option.getAttribute('data-title') || '';
  const price = option.getAttribute('data-price') || '';
  const image = option.getAttribute('data-image') || '';
  const imageSrcset = option.getAttribute('data-image-srcset') || '';

  card.dataset.activeId = id;
  card.setAttribute('data-id', id);

  card.querySelectorAll('[data-product-line-option]').forEach((btn) => {
    if (!(btn instanceof HTMLElement)) {
      return;
    }
    const isActive = btn.getAttribute('data-id') === id;
    btn.classList.toggle('is-active', isActive);
    btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
  });

  const titleLink = card.querySelector('[data-product-line-link]');
  if (titleLink instanceof HTMLAnchorElement) {
    if (url) {
      titleLink.href = url;
    }
    if (title) {
      titleLink.textContent = formatCardTitle(title);
    }
  }

  const thumb = card.querySelector('[data-product-line-thumb]');
  if (thumb instanceof HTMLAnchorElement && url) {
    thumb.href = url;
  }

  const img = card.querySelector('.product-card__image');
  if (img instanceof HTMLImageElement && image) {
    img.removeAttribute('data-image-loaded');
    img.classList.remove('is-reveal-pending');
    img.src = image;
    if (imageSrcset) {
      img.srcset = imageSrcset;
    }
    if (title) {
      img.alt = title;
      img.title = title;
    }
    card.removeAttribute('data-card-palette-inited');
    if (typeof window.ProstocvetInitProductCards === 'function') {
      window.ProstocvetInitProductCards(card.parentElement || document);
    }
  }

  const priceLink = card.querySelector('a.product-card__price:not(.read_more)');
  if (priceLink instanceof HTMLAnchorElement) {
    if (url) {
      priceLink.href = url;
    }
    if (price) {
      const priceSpan = priceLink.querySelector(':scope > span:first-child');
      if (priceSpan) {
        priceSpan.textContent = price;
      }
      priceLink.setAttribute('aria-label', `${formatCardTitle(title)}, ${price}`);
    }
  }

  card.querySelectorAll('.wish_item').forEach((wish) => {
    if (wish instanceof HTMLElement) {
      wish.setAttribute('data-item', id);
    }
  });
}

/**
 * Единая обрезка названия — как Misc::stripBouquetWrapper.
 * @param {string} name
 * @returns {string}
 */
function formatCardTitle(name) {
  let title = String(name ?? '');

  // Без кавычек название не трогаем.
  if (!/"/.test(title)) {
    return title.trim();
  }

  // «Букет из|живых … "Имя"» → Имя
  if (/^\s*Букет\s+(из|живых)\b/u.test(title)) {
    const quoted = title.match(/"([^"]+)"/u);
    if (quoted) {
      title = quoted[1];
    }
  } else {
    title = title.replace(/^\s*Букет\s+/u, '');
    title = title.replaceAll('Пионов', 'Пионы');
    title = title.replace(/"([^"]+)"/gu, '$1');
  }

  return title.trim();
}
